import { render, staticRenderFns } from "./error_alert.vue?vue&type=template&id=a4abd7e6&scoped=true&"
import script from "./error_alert.vue?vue&type=script&lang=js&"
export * from "./error_alert.vue?vue&type=script&lang=js&"
import style0 from "./error_alert.vue?vue&type=style&index=0&id=a4abd7e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4abd7e6",
  null
  
)

export default component.exports